<template>
  <div class="relative flex flex-col h-screen">
    <img :src="getImage('mascot')" class="fixed papsi-mascot" />

    <div class="flex flex-1 lg:flex-row flex-col">
      <SidebarSection>
        <div class="flex flex-col">
          <p class="text-primary text-5xl">{{ $t("msg002") }},</p>
          <p class="text-primary text-7xl font-bold mb-10">
            {{ $t("msg003") }}!
          </p>

          <LabelControl type="subtitle" :content="$t('lop001')" />
        </div>
      </SidebarSection>

      <ContentSection :show_logout="false">
        <div class="bg-white flex flex-col justify-center align-center mt-5">
          <div class="mb-10">
            <CardControl
              @click="handleRedirect('/login/papsi-mobile')"
              :rectangle="true"
              :width="50"
              :height="10"
              :title="$t('lop002')"
              icon_id="smartphone_green"
              :icon_height="60"
              :icon_width="60"
              :margin="30"
            ></CardControl>
          </div>

          <div class="mb-10">
            <CardControl
              @click="handleRedirect('/login/account-serial-number')"
              :rectangle="true"
              :width="50"
              :height="10"
              :title="$t('lop003')"
              icon_id="passbook"
              :icon_height="60"
              :icon_width="60"
              :margin="30"
            ></CardControl>
          </div>

          <div>
            <CardControl
              @click="handleRedirect('/login/scan-qr')"
              :rectangle="true"
              :width="50"
              :height="10"
              :title="$t('lop004')"
              icon_id="qr-green"
              :icon_height="60"
              :icon_width="60"
              :margin="30"
            >
            </CardControl>
          </div>
        </div>
      </ContentSection>
    </div>

    <FooterSection />
  </div>
</template>

<script>
import SidebarSection from "@/components/sections/SidebarSection.vue";
import ContentSection from "@/components/sections/ContentSection.vue";
import FooterSection from "@/components/sections/FooterSection.vue";
import mixin from "@/mixins/controls.js";
import LabelControl from "@/components/controls/LabelControl.vue";
import CardControl from "@/components/controls/CardControl.vue";

export default {
  mixins: [mixin],
  components: {
    SidebarSection,
    ContentSection,
    FooterSection,
    LabelControl,
    CardControl,
  },
  data() {
    return {
      inactivity_timeout: null,
    };
  },
  mounted() {
    this.$emit("checkauth", false);
    this.startInactivityTimer();
    window.addEventListener("touchstart", this.resetInactivityTimer);
  },
  beforeUnmount() {
    clearTimeout(this.inactivity_timeout);
    window.removeEventListener("touchstart", this.resetInactivityTimer);
  },
  methods: {
    resetInactivityTimer() {
      clearTimeout(this.inactivity_timeout);
      this.startInactivityTimer();
    },
    startInactivityTimer() {
      if (process.env.VUE_APP_DEVELOPMENT_MODE === "false") {
        this.inactivity_timeout = setTimeout(() => {
          this.$router.push({ name: "start-page" });
        }, process.env.VUE_APP_IDLE_DELAY || 30000);
      }
    },
  },
};
</script>

<style scoped>
.papsi-mascot {
  bottom: 0;
  left: 0;
  width: 25rem;
}

.papsi-text {
  height: 36rem;
}

@media (min-width: 2500px) {
  .card-container {
    height: 15rem !important;
    width: 75rem !important;
  }

  .mt-5 {
    margin-top: 5rem !important;
  }
}
</style>
